













































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { SearchCondition, Event } from "../../modules/teacher/EventList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  events: Event[]
  fields: any[]
  errors: string[]
  isAllCheckedDelete: boolean
  delete_ids: number[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 5,
      condition: new SearchCondition(),
      events: new Array<Event>(),
      fields: [
        {key: "event_code", label: "イベントCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "イベント名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center'},
      ],
      errors: [],
      isAllCheckedDelete: false,
      delete_ids: [],
    });

    /************************************************************
     * 削除処理
     ************************************************************/

    const deleteEvent = async (): Promise<void> => {

      if (!state.delete_ids.length) {
        alert(`削除するイベントをチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/event_list/delete`, {ids: state.delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    }

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/event_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.events = response.data.events.map((x: any) => new Event(x)); 
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/event_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `Event.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_ids = [];

      if (newVal) {
        state.delete_ids = state.events.map(x => x.id);
      }
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
    });

    return {
      ...toRefs(state),
      search,
      clearCondition,
      deleteEvent,
      download,
    };
  }
});
